import styled from 'styled-components';

import { font } from 'utils/styles';

export const Comments = styled.div`
  padding-top: 10px;
`;

export const Title = styled.div`
  ${font.medium}
  ${font.size(15)}
`;
